export default __webpack_public_path__ + "static/media/jo.b3f40259.svg";